import { PortfolioUtilities as portfolioUtilities, PortfolioUtilities } from '@common/portfolio.utilities';
class TradesGridController implements angular.IOnInit {

  public getData: () => any;
  public currencyCode: string;

  private gridOptions: any;

  /** @ngInject */
  constructor(private portfolioUtilities:portfolioUtilities, private $filter : any) {
  }


  $onInit() {
    // cannot set in cunstructor because binding has not yet happened
    this.gridOptions = {
      data: [],
      urlSync: false
    };

    this.getData()(this.currencyCode)
      .then((result) => {
        this.gridOptions.data = result.data;
      });
  }

  formatCurrency(currency) {
    
    return this.portfolioUtilities.formatCurrency(currency);
  }

}


export const tradesGrid: angular.IComponentOptions = {
  template: require('./tradesGrid.html'),
  controller: TradesGridController,
  bindings: {
    getData: "&",
    currencyCode: "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/components/tradesGrid.ts